import { render, staticRenderFns } from "./VisNodeForm.vue?vue&type=template&id=56dc6946&"
import script from "./VisNodeForm.vue?vue&type=script&lang=js&"
export * from "./VisNodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56dc6946')) {
      api.createRecord('56dc6946', component.options)
    } else {
      api.reload('56dc6946', component.options)
    }
    module.hot.accept("./VisNodeForm.vue?vue&type=template&id=56dc6946&", function () {
      api.rerender('56dc6946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/VisNodeForm.vue"
export default component.exports